import { render } from "./ModerationInfo.vue.js?vue&type=template&id=3d40cad9!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ModerationInfo.vue?vue&type=template&id=3d40cad9"
import script from "./ModerationInfo.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ModerationInfo.vue?vue&type=script&lang=js"
export * from "./ModerationInfo.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ModerationInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/apps/conversations/components/message/ModerationInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d40cad9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d40cad9', __exports__)) {
    api.reload('3d40cad9', __exports__)
  }
  
  module.hot.accept("./ModerationInfo.vue.js?vue&type=template&id=3d40cad9!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ModerationInfo.vue?vue&type=template&id=3d40cad9", () => {
    api.rerender('3d40cad9', render)
  })

}


export default __exports__